import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloTestDelete } from '@api/sdk.gen';
import { KubesoloTest } from '@api/types.gen';

import { withError } from '@/react-tools/react-query';
import { isAxiosError } from '@/react/portainer/services/axios/utils/isAxiosError';

import { queryKeys } from './queryKeys';

/** Cancels the test if it is running, and clears it so another can start. */
export function useClearConnectionTestMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: clearConnectionTest,
    onSuccess: () => queryClient.setQueryData(queryKeys.active(), null),
    ...withError('Unable to clear the connection test'),
  });
}

async function clearConnectionTest(id: KubesoloTest['id']) {
  try {
    await kubesoloTestDelete({ path: { id } });
  } catch (error) {
    // Portainer already dropped it, e.g. on restart, while the page still showed it
    if (isAxiosError(error) && error.response?.status === 404) {
      return;
    }

    throw error;
  }
}
